"use strict";

exports.__esModule = true;
exports.SizingType = exports.Breakpoint = void 0;
let Breakpoint = exports.Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["small"] = "small";
  // mobile
  Breakpoint["large"] = "large"; // desktop
  return Breakpoint;
}({});
let SizingType = exports.SizingType = /*#__PURE__*/function (SizingType) {
  SizingType["content"] = "content";
  SizingType["stretched"] = "stretched";
  SizingType["pixels"] = "pixels";
  return SizingType;
}({});
//# sourceMappingURL=presets.js.map